export class PushMessageActions {  

  static PUSH_MESSAGE_LOADED_TEST = "@PUSH_MESSAGE_LOADED_TEST";
  static PUSH_MESSAGE_LOADED = "@PUSH_MESSAGE_LOADED";

}